import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import EmployeesFormContainer from '../../../containers/organizations/EmployeesFormContainer.jsx';

const EditEmployees = ({ slug }) => (
  <>
    <Helmet>
      <title>Edit Organization Employees | ChangeSync</title>
    </Helmet>
    <EmployeesFormContainer slug={slug} />
  </>
);

EditEmployees.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditEmployees));
